import { Core } from '../core/core';
import { StorageAdapter } from '../interfaces/storage-adapter.interface';

export function storage(): StorageAdapter {
    return Core.storage;
}
